"use client"
import React, { useState } from 'react';

// ==========================================
// 1. STYLES & COLORS (Đồng bộ Dashboard)
// ==========================================
const colors = {
  bg: '#020617', cardBg: '#0f172a', border: '#1e293b',
  textMain: '#f8fafc', textSub: '#94a3b8',
  green: '#22c55e', greenBg: 'rgba(34, 197, 94, 0.1)',
  red: '#ef4444', redBg: 'rgba(239, 68, 68, 0.1)',
  warn: '#eab308', warnBg: 'rgba(234, 179, 8, 0.1)'
};

const baseStyles = {
  container: { backgroundColor: colors.bg, color: colors.textMain, padding: '16px', fontFamily: 'system-ui, sans-serif', minHeight: '100vh', boxSizing: 'border-box' },
  card: { backgroundColor: colors.cardBg, border: `1px solid ${colors.border}`, borderRadius: '12px', padding: '20px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5)', marginBottom: '24px' },
  gridHeader: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 3fr 1fr', gap: '8px', alignItems: 'center', color: colors.textSub, fontSize: '11px', textTransform: 'uppercase', paddingBottom: '12px', borderBottom: `1px solid ${colors.border}`, marginBottom: '12px', fontWeight: 'bold' },
  gridRow: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 3fr 1fr', gap: '8px', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.2)', padding: '10px 12px', borderRadius: '8px', fontSize: '12px', marginBottom: '6px', borderLeft: `4px solid transparent`, transition: 'all 0.2s' },
  tag: { padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', display: 'inline-block', textAlign: 'center' },
  select: { backgroundColor: colors.bg, border: `1px solid ${colors.border}`, color: colors.textMain, padding: '6px 12px', borderRadius: '6px', outline: 'none', cursor: 'pointer' }
};

const statusLabels = {
  up: '📈 Tăng',
  down: '📉 Giảm',
  neutral: '⚖️ Ngang' 
};

// ==========================================
// 2. EXPORT LOGIC ENGINE & DATA STATIC
// Dùng cục này cho Telegram Bot hoặc bất kỳ file nào khác
// ==========================================

export const analyzeOrderFlow = (p, v, o, c) => {
  let comment = "Sideway / Tín hiệu nhiễu";
  let winRate = 30;
  let signalType = "neutral"; 

  // --- TRƯỜNG HỢP GIÁ TĂNG ---
  if (p === 'up') {
    if (o === 'up' && c === 'up') {
      comment = "Trend Tăng (True Bull): Tiền mới nạp + Mua chủ động.";
      winRate = 85; signalType = "bullish";
    } else if (o === 'down' && c === 'up') {
      comment = "Short Squeeze (Cảnh báo): Tăng do lệnh Short cắt lỗ, dễ bẫy.";
      winRate = 55; signalType = "warning";
    } else if (o === 'up' && c === 'down') {
      comment = "Bullish Absorption: Gom hàng bằng lệnh Limit chờ sẵn.";
      winRate = 75; signalType = "bullish";
    } else if (o === 'down' && c === 'down') {
      comment = "Bearish Pullback: Tăng ảo, phe xả hàng đang kiểm soát.";
      winRate = 35; signalType = "bearish";
    } else {
      comment = "Tăng giá thiếu đồng thuận (Dễ điều chỉnh).";
      winRate = 45; signalType = "neutral";
    }
  } 
  // --- TRƯỜNG HỢP GIÁ GIẢM ---
  else if (p === 'down') {
    if (o === 'up' && c === 'down') {
      comment = "Trend Giảm (True Bear): Tiền mới nạp + Bán chủ động.";
      winRate = 85; signalType = "bearish";
    } else if (o === 'down' && c === 'down') {
      comment = "Long Liquidation (Cảnh báo): Giảm do quét thanh lý, dễ rút râu.";
      winRate = 55; signalType = "warning";
    } else if (o === 'up' && c === 'up') {
      comment = "Bearish Absorption: Xả hàng vào tay đội bắt đáy (Limit Buy).";
      winRate = 75; signalType = "bearish";
    } else if (o === 'down' && c === 'up') {
      comment = "Bullish Pullback: Giảm ảo, cạn cung, phe mua nhăm nhe.";
      winRate = 35; signalType = "bullish";
    } else {
      comment = "Giảm giá thiếu đồng thuận (Chờ xác nhận).";
      winRate = 45; signalType = "neutral";
    }
  } 
  // --- TRƯỜNG HỢP GIÁ ĐI NGANG ---
  else {
    if (o === 'up' && c === 'up') {
      comment = "Exhaustion (Cảnh báo Sập): Mua chủ động mạnh nhưng kẹt cản.";
      winRate = 70; signalType = "warning";
    } else if (o === 'up' && c === 'down') {
      comment = "Accumulation (Chuẩn bị Bơm): Bán chủ động mạnh nhưng bị đỡ giá.";
      winRate = 70; signalType = "bullish";
    } else if (o === 'down') {
      comment = "Thị trường chốt lời, cạn thanh khoản.";
      winRate = 20; signalType = "neutral";
    } else {
      comment = "Tích lũy vô hướng, đứng ngoài quan sát.";
      winRate = 40; signalType = "neutral";
    }
  }

  // Tinh chỉnh Win Rate dựa vào Volume (Vol lớn = Uy tín cao)
  if (v === 'up' && winRate >= 50) winRate += 10;
  if (v === 'down' && winRate > 30) winRate -= 15;
  if (winRate > 95) winRate = 95; // Capping

  return { comment, winRate, signalType };
};

// Sinh trước 81 trường hợp (Chạy 1 lần duy nhất khi nạp file)
export const ALL_MARKET_CASES = (() => {
  const states = ['up', 'down', 'neutral'];
  const cases = [];
  states.forEach(p => {
    states.forEach(v => {
      states.forEach(o => {
        states.forEach(c => {
          const key = `${p}_${v}_${o}_${c}`;
          const analysis = analyzeOrderFlow(p, v, o, c);
          cases.push({ key, p, v, o, c, ...analysis });
        });
      });
    });
  });
  return cases;
})();


// ==========================================
// 3. COMPONENT GIAO DIỆN UI (MARKET ANALYSIS)
// ==========================================
const MarketAnalysisStatic = () => {
  const [filterVol, setFilterVol] = useState('all');

  // Lọc và Nhóm dữ liệu từ ALL_MARKET_CASES đã export ở trên
  const filteredCases = filterVol === 'all' ? ALL_MARKET_CASES : ALL_MARKET_CASES.filter(c => c.v === filterVol);
  const upCases = filteredCases.filter(c => c.p === 'up');
  const downCases = filteredCases.filter(c => c.p === 'down');
  const neutralCases = filteredCases.filter(c => c.p === 'neutral');

  const getSignalUI = (type) => {
    switch(type) {
      case 'bullish': return { color: colors.green, bg: colors.greenBg, text: '🟢 LONG' };
      case 'bearish': return { color: colors.red, bg: colors.redBg, text: '🔴 SHORT' };
      case 'warning': return { color: colors.warn, bg: colors.warnBg, text: '⚠️ CẢNH BÁO' };
      default: return { color: colors.textSub, bg: 'rgba(255,255,255,0.05)', text: '⚪ QUAN SÁT' };
    }
  };

  const getWinRateColor = (rate) => {
    if (rate >= 70) return colors.green;
    if (rate >= 50) return colors.warn;
    return colors.red;
  };

  // Render lưới dữ liệu
  const renderGridSection = (title, cases) => (
    <div style={baseStyles.card}>
      <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: colors.textMain, marginBottom: '16px', borderBottom: `1px solid ${colors.border}`, paddingBottom: '12px' }}>
        {title} ({cases.length} Kịch bản)
      </h2>
      <div style={{ overflowX: 'auto', maxHeight: '500px' }}>
        <div style={{ minWidth: '950px' }}>
          
          {/* Grid Header */}
          <div style={baseStyles.gridHeader}>
            <div>Signal</div>
            <div>Price</div>
            <div>Volume</div>
            <div>OI</div>
            <div>CVD (Dòng tiền)</div>
            <div>Nhận định / Kịch bản (Logic Telegram)</div>
            <div style={{ textAlign: 'right' }}>Độ uy tín</div>
          </div>

          {/* Grid Rows */}
          {cases.sort((a,b) => b.winRate - a.winRate).map((data) => {
            const ui = getSignalUI(data.signalType);
            const wrColor = getWinRateColor(data.winRate);

            return (
              <div key={data.key} style={{ ...baseStyles.gridRow, borderLeftColor: wrColor }}>
                <div><span style={{...baseStyles.tag, backgroundColor: ui.bg, color: ui.color}}>{ui.text}</span></div>
                <div style={{ color: colors.textMain }}>{statusLabels[data.p]}</div>
                <div style={{ color: colors.textMain }}>{statusLabels[data.v]}</div>
                <div style={{ color: colors.textMain }}>{statusLabels[data.o]}</div>
                <div style={{ color: colors.textMain, fontWeight: 'bold' }}>{statusLabels[data.c]}</div>
                <div style={{ color: colors.textMain }}>{data.comment}</div>
                <div style={{ textAlign: 'right', fontWeight: 'bold', color: wrColor, fontSize: '14px' }}>
                  {data.winRate}%
                </div>
              </div>
            );
          })}

        </div>
      </div>
    </div>
  );

  return (
    <div style={baseStyles.container}>
      
      {/* HEADER CARD */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${colors.border}`, paddingBottom: '16px', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>🧠 NÃO BỘ AI: MA TRẬN 81 KỊCH BẢN (P-V-O-C)</h1>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ fontSize: '13px', color: colors.textSub }}>Lọc theo Volume:</span>
          <select value={filterVol} onChange={(e) => setFilterVol(e.target.value)} style={baseStyles.select}>
            <option value="all">Tất cả</option>
            <option value="up">Volume Tăng (Uy tín cao)</option>
            <option value="neutral">Volume Ngang</option>
            <option value="down">Volume Giảm (Uy tín thấp)</option>
          </select>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '24px' }}>
        {/* INFO CARD 1 */}
        <div style={baseStyles.card}>
          <div style={{ color: colors.textMain, fontWeight: 'bold', borderBottom: `1px solid ${colors.border}`, paddingBottom: '8px', marginBottom: '12px' }}>
            🎯 MỤC ĐÍCH SỬ DỤNG
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px', color: colors.textSub, lineHeight: '1.5' }}>
            Bảng ma trận này đóng vai trò là <strong>Rules Engine (Bộ Luật)</strong> cho Telegram Bot. Thay vì báo loạn xạ, Bot sẽ lấy Giá Live, soi cấu trúc Price, Vol, OI, CVD. 
            Chỉ khi nào <strong>Trùng khớp với các Case có Độ Uy tín {'>'} 70%</strong> thì mới kích hoạt tin nhắn gửi về điện thoại của bạn.
          </div>
        </div>

        {/* INFO CARD 2 */}
        <div style={baseStyles.card}>
          <div style={{ color: colors.textMain, fontWeight: 'bold', borderBottom: `1px solid ${colors.border}`, paddingBottom: '8px', marginBottom: '12px' }}>
            📖 SỨC MẠNH CỦA CVD & OI
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '13px', color: colors.textSub }}>
            <div><strong style={{color: colors.green}}>CVD Tăng:</strong> Phe Mua chủ động (Táp thẳng vào lệnh rổ).</div>
            <div><strong style={{color: colors.red}}>CVD Giảm:</strong> Phe Bán chủ động xả.</div>
            <div><strong style={{color: colors.textMain}}>OI Tăng:</strong> Tiền mới bơm vào sòng.</div>
            <div><strong style={{color: colors.warn}}>OI Giảm:</strong> Hoảng loạn đóng lệnh, chốt lời.</div>
          </div>
        </div>
      </div>

      {/* 3 DATA GRIDS */}
      {renderGridSection('🟢 TRƯỜNG HỢP 1: PRICE = UP (GIÁ TĂNG)', upCases)}
      {renderGridSection('🔴 TRƯỜNG HỢP 2: PRICE = DOWN (GIÁ GIẢM)', downCases)}
      {renderGridSection('⚖️ TRƯỜNG HỢP 3: PRICE = NEUTRAL (GIÁ ĐI NGANG)', neutralCases)}

      {/* FOOTER */}
      <div style={{ textAlign: 'center', marginTop: '32px', color: colors.textSub, fontSize: '13px', padding: '20px' }}>
        <p>⚡ Hệ thống Tự sinh (Auto-generated) 81 Kịch bản Dòng tiền dựa trên Order Flow.</p>
      </div>

    </div>
  );
};

export default MarketAnalysisStatic;
